import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import { configurePublicActivityMiddleware } from '../middleware/PublicActivityMiddleware';
import { configureViewerCacheMiddleware } from '../middleware/ViewerCacheMiddleware';
import { PDF_ACTION_TYPES } from 'documents-lib/js/constants/ActionTypes';
import { VIEWER_ACTION_TYPES } from '../constants/ActionTypes';
import { errorMiddleware } from 'documents-lib/js/middleware/errorMiddleware';
const {
  VIEW_PDF_PAGE,
  CHANGE_PAGE_CHIRP
} = PDF_ACTION_TYPES;
const {
  VIEWER_IDENTIFIED,
  VIEWER_FINISHED,
  VIEWER_IDENTIFIED_CHIRP,
  VIEWER_FINISH_SESSION_CHIRP
} = VIEWER_ACTION_TYPES;
const composeWithEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const PublicActivityMiddleware = configurePublicActivityMiddleware(state => state.view.presentation, {
  identify: VIEWER_IDENTIFIED,
  viewPage: VIEW_PDF_PAGE,
  finish: VIEWER_FINISHED,
  identifyCHIRP: VIEWER_IDENTIFIED_CHIRP,
  changePageCHIRP: CHANGE_PAGE_CHIRP,
  finishSessionCHIRP: VIEWER_FINISH_SESSION_CHIRP
});
const ViewerCacheMiddleware = configureViewerCacheMiddleware(VIEWER_IDENTIFIED);
const ViewerCacheCHIRPMiddleware = configureViewerCacheMiddleware(VIEWER_IDENTIFIED_CHIRP);
const createStoreWithMiddleware = composeWithEnhancers(applyMiddleware(thunk, PublicActivityMiddleware, ViewerCacheMiddleware, ViewerCacheCHIRPMiddleware, errorMiddleware))(createStore);
export function configureStore(initialState) {
  return createStoreWithMiddleware(rootReducer, initialState);
}